import React from 'react';
import styled from 'styled-components';
import { H1, H5 } from '@futurefamily/ef-components';
import TreatmentForm from '../TreatmentForm';

const Wrapper = styled.div`
  padding-top: var(--page-top-offset);
  padding-bottom: 28px;
`;

const Heading = styled(H1)`
  font-family: var(--font-family-secondary);
  color: var(--teal);
  text-align: center;
`

const SubHeading = styled(H5)`
  font-family: var(--font-family-primary);
  text-align: center;
`

export function TreatmentOptions () {
  return (
    <Wrapper className="container">
      <Heading>Fertility Treatment Payment Options</Heading>

      <div className="row justify-content-center">
        <div className="col">
          <SubHeading className="mb-5">To better understand fertility treatment costs and payment options, just answer a few questions</SubHeading>
        </div>
      </div>

      <TreatmentForm />
    </Wrapper>
  );
}

export default TreatmentOptions;
